import $ from "jquery";
import compile from "@bd-utils/handlerbars-helper";
import BD_Component from "@bd-core/bd-component";
import fb from "@bd-core/firebase";
import bdapi from "@bd-core/bd-api";
import bdjs from "@bd-core/bdjs";
import CONFIG from "@bd-core/config";
import { getState } from "@bd-stores/store";
import { getCurrentPageId } from "@bd-stores/user-progress";
import {
    getPlayers,
    getRoomStatus,
    getTeamAnswers,
    getFinalTeamAnswers,
} from "@bd-stores/game-progress";
import {
    maybeUpdateRoomStatus,
    updateRoomAnswer,
    saveFinalRoomAnswers,
} from "@bd-core/firebase-actions";


export class RoomSwitchPuzzle extends BD_Component {
    constructor() {
        super();

        this.id = "switch_puzzle";
        this.templateID = "switch_puzzle-template";

        this.elms = {
            puzzleContent: "#switchPuzzle",
            puzzleOverlay: ".js-puzzle-popup",
            openPuzzle: ".js-switchPuzzle-open",
            closePuzzle: ".js-switchPuzzle-close",
            puzzleItem: ".js-puzzle-item",
            panelItem: ".js-panel-item",
            actions: ".js-actions",
            submitBtn: ".js-submit-btn",
            closeNotMatch: ".js-mismatch-close",
            answerMismatch: ".js-answer-mismatch",
            answerWaiting: ".js-answer-waiting",
            answerWrong: ".js-answer-wrong",
            background: ".js-screen-img",
            backgroundImage: ".screen__navigate",
            lightAnswer: ".js-sync-answer",
            resultFeedback: ".js-feedback",
            hintBtn: ".js-hint-btn",
            openDilemma: ".js-merging",
            dilemma: ".js-dilemma",
            dilemmaItem: ".js-dilemma-item",
            character: ".js-dilemma-character",
            seeMoreBtn: ".js-seemore",
            closeAdviceBtn: ".js-close-advice"
        };

        this._events = this.getEvents();

        this.fbEvents = [];

        this.userAnswers = {};
    }

    /**
     * @returns {Array<BD_ComponentEvent>}
     */
    getEvents() {
        const elms = this.elms;
        return [
            {
                event: "click",
                selector: elms.submitBtn,
                handler: this.submit,
            },
            {
                event: "click",
                selector: elms.dilemmaItem,
                handler: this.chooseItem
            },
            {
                event: "click",
                selector: elms.openDilemma,
                handler: this.openDilemma
            },
        ];
    }

    beforeInit() {
        this.render();
        this.setGameState();
        const roomStatus = getRoomStatus(this.roomId);
        if (roomStatus !== "is-status-completed") this.listenScannedUsers();

        this.setDilemmaSlider();
    }

    getModifiedData() {
        const modified = { ...this._data };
        const defaultImageBg = `${CONFIG.themeURL}/assets/images/bg-switch-puzzle-new.png`;

        const _image_bg = this._data.image_bg
            ? this._data.image_bg
            : defaultImageBg;

        const modifiedData = {
            ...modified,
            image_bg: _image_bg,
        };

        return modifiedData;
    }

    render() {
        const modifiedData = this.getModifiedData();

        const htmlTemplate = $("#" + this.templateID).html();
        const html = compile(htmlTemplate, modifiedData);
        $(".app").html(html);
    }

    setGameState() {
        const elms = this.elms;
        const roomID = this.roomId;
        const thisRoomStatus = getRoomStatus(roomID);
        const currentPlayerId = CONFIG.user.id;

        const possibleStatuses = [
            "is-status-open",
            "is-status-started",
            "is-status-completed",
        ];

        if (thisRoomStatus) {
            const $status = $(".js-room-status");
            $status.removeClass(possibleStatuses);
            $status.addClass(thisRoomStatus);
        }

        const setSelectedItem = (answers) => {
            $.each(answers, function (index, answer) {
                const itemId = String(index);
                const {keep, remove} = answer;
                const $dilemma = $(`${elms.dilemma}[data-id="${itemId}"]`);
                const $keepItem = $dilemma.find(`${elms.dilemmaItem}[data-id="${keep}"]`);
                const $removeItem = $dilemma.find(`${elms.dilemmaItem}[data-id="${remove}"]`);

                $keepItem.addClass("is-selected");
                $removeItem.addClass("is-selected");
            });
        };

        if (thisRoomStatus == "is-status-completed") {
            const finalAnswer = getFinalTeamAnswers(roomID);
            if (finalAnswer) setSelectedItem(finalAnswer);

            $(elms.submitBtn)
                .prop("disabled", true)
                .addClass("is-completed");

            $(".app__page").addClass("is-room-completed");

        } else {
            const roomAnswers = getTeamAnswers(roomID);

            if (!roomAnswers) return;

            const myAnswer = currentPlayerId in roomAnswers;

            if (myAnswer) {
                setSelectedItem(roomAnswers[currentPlayerId]);
                $(elms.submitBtn).addClass("is-submitted");
            }
        }
    }

    // ============================== CUSTOM FUNCTION

    setDilemmaSlider() {
        $(".js-dilemma-slider").slick({
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            prevArrow: $(".js-dilemma-prev"),
            nextArrow: $(".js-dilemma-next"),
            dots: true,
            appendDots: $(".js-dilemma-paging"),
            customPaging: function (slider, i) {
                // eslint-disable-next-line no-unused-vars
                var thumb = $(slider.$slides[i]).data(); // Ensure data attributes are defined in the slides
                return '<a>' + '</a>';
            }
        });
    }

    openDilemma() {
        $(".js-dilemma-screen").addClass("is-open")
        $(".js-switchPuzzle").addClass("dilemma-is-open")
    }

    chooseItem(e, el) {
        const roomID = this.roomId;
        const roomStatus = getRoomStatus(roomID);
        if(roomStatus === "is-status-completed") return;

        const $el = $(el);
        const elms = this.elms;
        const type = $el.attr("data-type");
        const selectedId = $el.attr("data-id");
        const $dilemma = $el.parents(elms.dilemma);
        const dilemmaId = $dilemma.attr("data-id");
        const $dilemmaItems = $dilemma.find(`${elms.dilemmaItem}[data-type="${type}"]`);

        $.each($dilemmaItems, function(index, item) {
            $(item).removeClass("is-selected");
        });

        const savedAnswers = this.userAnswers?.[dilemmaId] || {};

        const answerData = {
            ...this.userAnswers,
            [dilemmaId] : {
                    ...savedAnswers,
                [type] : selectedId
            },
        };

        this.userAnswers = answerData;
        $el.addClass("is-selected");
        this.toggleSubmitBtn();
    }

    toggleSubmitBtn() {
        const elms = this.elms;
        const $submitBtn = $(elms.submitBtn);
        const $dilemmas = $(elms.dilemma).not(`.slick-cloned ${elms.dilemma}`);
        let isAllAnswered = true;

        $.each($dilemmas, function(index, item) {
            const $keepItem = $(item)
                .find(`${elms.dilemmaItem}[data-type="keep"]`)
                .hasClass("is-selected");
            const $removeItem = $(item)
                .find(`${elms.dilemmaItem}[data-type="remove"]`)
                .hasClass("is-selected");
            const isAnswered = $keepItem && $removeItem;

            if(!isAnswered) return (isAllAnswered = false);
        });
        
        $submitBtn.removeClass("is-submitted");
        $submitBtn
        .prop("disabled", !isAllAnswered);
    }

    submit(e, el) {
        const roomID = this.roomId;
        const roomStatus = getRoomStatus(roomID);
        if(roomStatus === "is-status-completed") return;

        const currentPlayerId = CONFIG.user.id;
        let roomStarted = "is-status-started";
        let playerAnswers = this.userAnswers;

        updateRoomAnswer(roomID, {
            [currentPlayerId]: playerAnswers
        });

        maybeUpdateRoomStatus(roomID, roomStarted)
        .then(() => {
            $(el).addClass("is-submitted");
        })
        .catch();
    }

    checkIsAllAnswered(answers) {
        const players = getPlayers();
        const totalOnlinePlayer = players.filter((p) => p.isOnline).length;

        if (answers == null) return false;

        const totalPlayerAnswer = Object.keys(answers).length;

        if (totalPlayerAnswer < totalOnlinePlayer) return false;

        return true;
    }

    checkIsAllAnswersCorrect(answers) {
        if(answers === null) return false;

        const players = getPlayers();
        // get online players
        const onlinePlayer = players.filter((p) => p.isOnline);
        const totalOnlinePlayer = onlinePlayer.length;

        // get online player answers
        let onlinePlayerAnswers = [];
        onlinePlayer.forEach(function(player) {
            const {userId} = player;
            const playerAnswer = answers?.[userId];

            if(playerAnswer) {
                onlinePlayerAnswers.push(playerAnswer);
            }
        });

        // validate and checking player answers
        const answersLength = onlinePlayerAnswers.length;
        let objEqual = true;

        if(!onlinePlayerAnswers.length) return (objEqual = false);

        if(answersLength < totalOnlinePlayer) return (objEqual = false);

        onlinePlayerAnswers.forEach(function(answer, index) {
            if(index > 0) {
                let prev = onlinePlayerAnswers[
                    ($.inArray(answer, onlinePlayerAnswers) + 1) % answersLength
                ];

                const prevKeys = Object.keys(prev).sort();
                const answerKeys = Object.keys(answer).sort();

                const areEqual = prevKeys.every((key, index) => {
                    const objValue1 = prev[key];
                    const objValue2 = answer[answerKeys[index]];
                    const isValue1Same = objValue1.keep == objValue2.keep;
                    const isValue2Same = objValue1.remove == objValue2.remove;

                    return isValue1Same && isValue2Same;
                });

                if(!areEqual) {
                    $(".js-switchPuzzle").addClass("is-answer-mismatch");
                    return (objEqual = false);
                } else {
                    $(".js-switchPuzzle").removeClass("is-answer-mismatch");
                }
            }
        });

        return objEqual;
    }

    getCorrectAnswer(answers) {
        const playersAnswers = bdjs.indexedObjectToArray(answers);
        const lastCorrectAnswer = playersAnswers.pop();

        return lastCorrectAnswer;
    }

    maybeReadyToFinishTheGame() {
        const gameProgress = getState().gameProgress;
        const isAllRoomCompleted = gameProgress.allRoomCompleted;

        if (isAllRoomCompleted) {
            bdjs.goAsync(
                bdapi.post("game/finish-game", {
                    middle_state: getState().gameProgress.isMiddleState ? 1 : 0,
                }),
            );
        }
    }

    /**
     * If current user hasn't answered anything, don't do anything
     * If all user already submit the answer, room completed
     *
     * That is only applied for user that are currently online, offline user
     * would be ignored
     *
     * @param {*} snapshot
     */
    scanUsersListener(snapshot) {
        const playersAnswer = snapshot.val();
        const completed = "is-status-completed";
        const roomID = getCurrentPageId();
        const hasBeenCompleted = getRoomStatus(roomID) === completed;
        const hasAllPlayersAnswered = this.checkIsAllAnswered(playersAnswer);
        const isAllAnswerCorrect = this.checkIsAllAnswersCorrect(playersAnswer);
        const finalAnswer = this.getCorrectAnswer(playersAnswer);

        if (hasBeenCompleted) return;

        if (playersAnswer == null) return;

        if (!hasAllPlayersAnswered) {
            $(".js-switchPuzzle").addClass("is-answer-waiting");
            return;
        } else {
            $(".js-switchPuzzle").removeClass("is-answer-waiting");
        }

        if (!isAllAnswerCorrect) return;

        saveFinalRoomAnswers(roomID, finalAnswer);
        maybeUpdateRoomStatus(roomID, completed);
        this.maybeReadyToFinishTheGame();
    }

    /**
     * Callback to check whether the room is ready to finish
     */
    maybeReadyToFinish() {
        if (this.isTheRoomFinish()) return;

        const roomID = this.roomId;
        fb.get(`${fb.roomsPath}/${roomID}/answers`).then(
            this.scanUsersListener.bind(this),
        );
    }

    /**
     * Listener
     * @param {boolean} off turn on/off the event listener
     */
    listenScannedUsers(off = false) {
        const roomID = this.roomId;
        const path = `${fb.roomsPath}/${roomID}/answers`;
        const scanHandler = (data) => this.scanUsersListener(data);
        const finishHandler = () => this.maybeReadyToFinish();

        if (off) {
            this.fbEvents.forEach((fn) => fn.call());
            this.fbEvents = [];
        } else {
            const ansListener = fb.onValue(path, scanHandler);
            const plyListerner = fb.onValue(fb.playersPath, finishHandler);

            this.fbEvents.push(ansListener);
            this.fbEvents.push(plyListerner);
        }
    }

    isTheRoomFinish() {
        return getRoomStatus(this.roomId) == "is-status-completed";
    }

    beforeDestroy() {
        // if(this._data.must_in_room) this.cancel();
        this.listenScannedUsers(true);
    }
}
